import React, { useContext, useMemo, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';
import { Grid, Typography, InputLabel, Stack, TextField, FormControl, MenuItem, Button, Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, MenuList, Menu } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { IoMdArrowDropdown } from 'react-icons/io';
import { DateTimePicker } from '@mui/x-date-pickers';
import moment from 'moment-timezone';
import TimeCards from './Components/TimeCards';
import { LanguageContext } from '../../../../../../../../libs/Context';

interface TimeZonePlanner
{
	first : string;
	second : string;
	third : string;
}

const TimePlanner = (props) =>
{
	const { open, handleClose, formDate, handleSubmit, selectedZone } = props;
	const { language } = useContext(LanguageContext);
	const timezones = moment.tz.names();
	const [ search, setSearch ] = useState('');
	const [ selectedItem, setSelectedItem ] = useState<TimeZonePlanner>({
		first  : selectedZone ?? 'Asia/Kolkata',
		second : 'Asia/Kolkata',
		third  : 'Asia/Kolkata'
	});
	const [ date, setDate ] = useState<any>(formDate ?? dayjs(new Date().valueOf()));
	const [ anchorEls, setAnchorEls ] = useState({ 0: null, 1: null, 2: null });

	const handleClick = (event, index) =>
	{
		setAnchorEls((prev) => ({
			...prev,
			[index] : event.currentTarget

		}));
	};

	const handleCloseMenu = (index) =>
	{
		setAnchorEls((prev) => ({
			...prev,
			[index] : null

		}));
	};

	const handleMenuItemClick = (key: string, item, ind) =>
	{
		setSelectedItem((prev) => ({ ...prev, [key]: item }));
		setSearch('');
		handleCloseMenu(ind);
	};
	const handleChange = (newValue: any) =>
	{
		setDate(newValue);
	};
	const timeZones = [
		{
			bgcolor  : 'var(--primaryColor)',
			date     : 'June 17, 2024',
			time     : '05 : 25 PM - (IST) ',
			location : 'Chennai, Kolkata, New Delhi',
			id       : 'first'
		},
		{
			bgcolor  : 'var(--gray80)',
			date     : 'June 17, 2024',
			time     : '03 : 30 PM - (IST) ',
			location : 'Bangkok, Hanoi, Jakarta',
			id       : 'second'
		},
		{
			bgcolor  : 'var(--gray80)',
			date     : 'June 17, 2024',
			time     : '10 : 30 PM - (IST) ',
			location : 'Hawaii',
			id       : 'third'
		}
	];

	const filteredTimezones = useMemo(() =>
	{
		return timezones.filter((tz) =>
			tz.toLowerCase().includes(search.toLowerCase()));
	}, [ timezones, search ]);

	const GetDate = (dt) =>
	{
		return new Date(dt);
	};

	const disableApply = () =>
	{
		return Boolean(formDate === date);
	};

	const HandleApply = () =>
	{
		handleSubmit(date);
		handleClose();
	};

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
			fullWidth
			maxWidth='md'
		>
			<DialogTitle id='alert-dialog-title'>
				<Grid container justifyContent={'space-between'} alignItems={'start'}>
					<Grid item>
						<Typography variant='h6' fontWeight='var(--font500)'>
							{language?.time_zonde_planner}
						</Typography>
						<Typography variant='subtitle2' fontWeight='var(--font400)'>
							{language?.time_zonde_discription}
						</Typography>
					</Grid>
					<Grid item onClick={handleClose} className='pointer'>
						<RxCross2/>
					</Grid>
				</Grid>
			</DialogTitle>
			<DialogContent>
				<Grid container flexDirection={'column'} >
					<Grid item lg={4} sm={4} md={4} xs={12} spacing={2}>
						<Stack spacing={1} direction={'column'}>
							<InputLabel >
								<Typography variant='body1' fontWeight='var(--font500)' color={'textPrimary'} pb='var(--pixel8)'>{language?.meeting_start_time}  </Typography>
							</InputLabel>
							<FormControl sx={{ width: 'var(--percent100)' }} size='small'>
								<LocalizationProvider dateAdapter={AdapterDayjs} >
									<DateTimePicker
										value={date}
										className='fullWidth datetimeTxt'
										inputFormat='DD/MM/YYYY hh:mm a'
										onChange={handleChange}
										disablePast
										minDate={dayjs()}
										renderInput={(params) => <TextField {...params} size='small'/>}
									/>
								</LocalizationProvider>
							</FormControl>
						</Stack>
					</Grid>
					<Grid container item spacing={2} pt='var(--pixel16)' display='flex' alignItems='center' justifyContent='center'>
						{timeZones.map((zone) => (
							<TimeCards
								key={zone?.id}
								date={GetDate(new Date(date).valueOf())}
								timezone={selectedItem[zone?.id ?? 'first']}
								bgcolor={zone?.bgcolor}
							/>
						))}
					</Grid>
					<Grid container spacing={1} mt={1}>
						{[ 'first', 'second', 'third' ].map((each, index) => (
							// this is previous code i change according to my condition
							// <Grid item lg={4} sm={4} md={4} xs={12} key={generateRandomUUID()}>

							<Grid item lg={4} sm={4} md={4} xs={12} key={each}>
								<TextField
									variant='outlined'
									type='text'
									size='small'
									fullWidth
									onClick={(event) => handleClick(event, index)}
									placeholder={language?.search_time_zone}
									// value={index === 0 ? first : showVal(index) ?? ''}
									value={selectedItem[each] ?? ''}
									InputProps={{
										endAdornment : (
											<InputAdornment position='start'>
												<IoMdArrowDropdown fontSize='var(--pixel20)'/>
											</InputAdornment>
										)
									}}
									sx={{
										cursor                     : 'pointer',
										'& .MuiOutlinedInput-root' : {
											cursor : 'pointer'
										},
										'& .MuiOutlinedInput-input' : {
											cursor : 'pointer'
										}
									}}
								/>
								<Menu
									id={`menu-${index}`}
									anchorEl={anchorEls[index]}
									open={Boolean(anchorEls[index])}
									onClose={() => handleCloseMenu(index)}
									anchorOrigin={{
										vertical   : 'bottom',
										horizontal : 'left'
									}}
									transformOrigin={{
										vertical   : 'top',
										horizontal : 'left'
									}}
									sx={{ '& .MuiPaper-root': { maxHeight: 'var(--font200)', maxWidth: 'var(--font280)' } }}
								>
									<MenuList>
										<MenuItem>
											<TextField
												variant='outlined'
												type='search'
												size='small'
												sx={{ width: 400 }}
												value={search}
												onChange={(e) => setSearch(e.target.value.replace(/^\s+/, ''))}
												placeholder={language?.searchDot}
												InputProps={{
													endAdornment : (
														<InputAdornment position='end'>
															<SearchIcon />
														</InputAdornment>
													)
												}}
												id='search'
											/>
										</MenuItem>
										{filteredTimezones.map((tz) => (
											<MenuItem key={tz} value={tz}
												onClick={() => handleMenuItemClick(each, tz, index)}
											>
												({moment.tz(tz).format('Z')}) {tz}
											</MenuItem>))
										}
									</MenuList>
								</Menu>
							</Grid>
						))}
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Stack direction='row' p='var(--pixel16)' alignItems={'center'} display={'flex'}>
					<Button disableElevation disableFocusRipple disableRipple disableTouchRipple variant='outlined' onClick={handleClose}>
						{language?.cancel}</Button>
					<Typography pl='var(--pixel16)'>
						<Button onClick={HandleApply} disabled={disableApply()} disableElevation disableFocusRipple disableRipple disableTouchRipple variant='contained' className='whiteTxt'>
							{language?.apply}
						</Button>
					</Typography>
				</Stack>
			</DialogActions>
		</Dialog>
	);
};

export default TimePlanner;